import { Component, PLATFORM_ID, TransferState, effect, inject, makeStateKey, untracked, DOCUMENT } from '@angular/core';
import { NavigationCancel, Router, RouterOutlet } from '@angular/router';
import { EventService } from './services/event.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { ApiService } from './services/api.service';
import { LoaderComponent } from './shared/loader/loader.component';
import { AlertService } from './services';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { SUBMENU_SLUGS } from './services/static';

@Component({
  selector: 'bluetees-admin',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  protected title = 'BlueTees-Admin';
  // protected updateAvailable: boolean = false;

  private event = inject(EventService);
  private transferState = inject(TransferState);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  private api = inject(ApiService);
  private alert = inject(AlertService);
  // private document = inject(DOCUMENT);

  constructor() {
    // this.swUpdate.versionUpdates.subscribe((res: any) => {
    //   res.type !== "VERSION_READY" && console.log("Site already Updated");
    //   res && res.type === "VERSION_READY" && res.currentVersion.hash !== res.latestVersion.hash && (this.updateAvailable = true)
    // })

    const _router = toSignal(this.router.events);
    effect(() => {
      const router = _router();
      untracked(() => {
        this.transferState.set(makeStateKey<boolean>('isLoggedIn'), this.event.isLoggedIn());

        if (router instanceof NavigationCancel && isPlatformBrowser(this.platformId) && !this.event.isLoggedIn()) this.router.navigate(['/login']);
        if (router instanceof NavigationCancel && isPlatformBrowser(this.platformId) && this.event.isLoggedIn()) this.router.navigate(['/dashboard']);
      })
    });

    effect(() => {
      if (this.event.isLoggedIn() && !this.event.user()) {
        untracked(() => {
          this.userDataFetch()
        })
      }
    })
  }

  private userDataFetch(): void {
    const userSubscriber: Subscription = this.api.get(`/profile`).subscribe({
      next: (response: any) => {
        if (response.type === 'success') {
          response.data && response.data.rolePermission && response.data.rolePermission.permission.forEach((element: any) => {
            element.selected = false;
            element.hasSubmenu = SUBMENU_SLUGS.includes(element.slug)
          });
          this.event.user.set(response.data);
        }
      },
      error: (error: any) => {
        this.alert.alert(error.message, 'warning');
        this.api.logout()
      },
      complete: () => {
        userSubscriber && userSubscriber.unsubscribe();
      },
    })
  }

  // protected activateUpdate(): void {
  //   this.swUpdate.activateUpdate().then((e) => {
  //     if (e) {
  //       this.updateAvailable = false;
  //       typeof this.document !== 'undefined' && this.document.location.reload()
  //     }
  //     setTimeout(() => {
  //       this.updateAvailable && (this.updateAvailable = false);
  //       typeof this.document !== 'undefined' && this.document.location.reload()
  //     }, 2000)
  //   })
  // }
}
